<template>
  <div class="new-home">
    <!-- 顶部导航栏 -->
    <header class="navbar">
      <div class="container">
        <div class="logo">
          <img src="@/assets/img/leftIcon.png" alt="AI魔方 logo - All in One的AI综合体" />
        </div>
        <nav class="nav-links" :class="{ 'is-open': isMobileMenuOpen }">
          <a href="#" class="nav-link" @click="scrollToBrowser">浏览器</a>
          <a href="#" class="nav-link" @click="scrollToInput">输入法</a>
          <a href="#" class="nav-link" @click="scrollToWorkstation">AI工位</a>
          <a href="#" class="nav-link" @click="scrollToAbout">关于我们</a>
          <a href="#" class="nav-link btn-primary" @click="scrollToDownload">立即下载</a>
        </nav>
        <div class="mobile-menu-btn" @click="toggleMobileMenu">
          <span class="hamburger" :class="{ 'is-active': isMobileMenuOpen }">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </div>
      </div>
    </header>

    <!-- 英雄区域 -->
    <section class="hero">
      <div class="container">
        <div class="hero-content">
          <h1>AI魔方 - All in One的AI综合体</h1>
          <p>自动部署Deepseek/Qwen3大模型，立即拥有私有AI算力。自助整合各大AI并用，交叉验证，内容输出更优质，结果更满意。</p>
          <div class="hero-buttons">
            <a href="#" class="btn-primary" @click="scrollToDownload">立即下载</a>
            <!-- <a href="/new-home/features" class="btn-secondary">了解更多</a> -->
          </div>
        </div>
        <div class="hero-image">
          <img src="@/assets/img/firstPage.png" alt="AI魔方产品界面 - All in One的AI综合体" />
        </div>
      </div>
    </section>

    <!-- 功能特性 -->
    <section class="features" id="features-section">
      <div class="container">
        <h2>核心功能</h2>
        <div class="features-grid">
          <div class="feature-card">
            <div class="feature-icon">
              <i class="iconfont">⚙️</i>
            </div>
            <h3>大模型部署</h3>
            <p>自动部署Deepseek/Qwen3大模型，立即拥有私有AI算力</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <i class="iconfont">🤖</i>
            </div>
            <h3>AI Agent</h3>
            <p>让AI替你操作，定制AI Agent APP，快捷打开软件文件</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <i class="iconfont">🔍</i>
            </div>
            <h3>AI浏览器</h3>
            <p>多个引擎，多种AI，纯净无广，一键直达</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <i class="iconfont">⌨️</i>
            </div>
            <h3>智能输入法</h3>
            <p>高效输入，知识管理，智能唤起AI</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <i class="iconfont">🏢</i>
            </div>
            <h3>AI工位</h3>
            <p>支持定制高性价比，自定Logo，彰显企业文化和归属感</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <i class="iconfont">📚</i>
            </div>
            <h3>本机知识库</h3>
            <p>自带本机知识库，消除AI幻觉，AI言之有物</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品展示 -->
    <section class="product-showcase">
      <div class="container">
        <div class="showcase-item">
          <div class="showcase-content">
            <h2>AI Agent APP</h2>
            <p>让AI替你操作，定制AI Agent APP。开启快捷打开软件文件，AI群多个AI引擎同屏作答、取长补短，AI写作辅助化整为零、多次蒸馏、高自由度，AI笔记记录你的创意灵感与经验沉淀，收藏订阅构建个人知识库、团队订阅与共享。</p>
            <!-- <a href="/new-home/features" class="btn-primary">了解更多</a> -->
          </div>
          <div class="showcase-image">
            <img src="https://seaweedfs.thumpai.cn/4,03f50a268a9a.png" alt="AI Agent功能展示 - AI魔方" />
          </div>
        </div>
        <div class="showcase-item reverse" id="browser-section">
          <div class="showcase-content">
            <h2>AI浏览器</h2>
            <p>多个引擎，多种AI，纯净无广，一键直达。无广告，协同搜索本机、互联网的相关内容，多源数据、AI检索增强。不存储用户隐私数据，界面简约清爽，程序敏捷。</p>
            <!-- <a href="/new-home/features" class="btn-primary">了解更多</a> -->
          </div>
          <div class="showcase-image">
            <img src="https://seaweedfs.thumpai.cn/1,03f6a7703776.png" alt="AI浏览器功能展示 - AI魔方" />
          </div>
        </div>
        <div class="showcase-item" id="input-section">
          <div class="showcase-content">
            <h2>智能输入法</h2>
            <p>高效输入，知识管理，智能唤起AI。无缝切换，支持导入常用词库，延续输入习惯；ctrl c/v复合剪贴板，自动记忆，连续粘贴；知识库语句调用，输入关键词迅速查看、调用、管理知识库中候选语句文章，实现一键上屏；AI智能唤起，AI即时响应作答，指令高度自定义。</p>
            <!-- <a href="/new-home/features" class="btn-primary">了解更多</a> -->
          </div>
          <div class="showcase-image">
            <img src="@/assets/img/inputPage.png" alt="智能输入法功能展示 - AI魔方" />
          </div>
        </div>
        <div class="showcase-item reverse" id="workstation-section">
          <div class="showcase-content">
            <h2>AI工位</h2>
            <p>支持定制高性价比，自定Logo，彰显企业文化和归属感。独立部署，输入行为数据不泄露；单位文库，拟文引用规范，杜绝外部数据污染；PGC对接原有知识库，内外网全满足；UGC同步到单位文库。</p>
            <!-- <a href="/new-home/features" class="btn-primary">了解更多</a> -->
          </div>
          <div class="showcase-image">
            <img src="https://seaweedfs.thumpai.cn/1,03f7c4aa55c4.jpg" alt="AI工位功能展示 - AI魔方" />
          </div>
        </div>
      </div>
    </section>

    <!-- 下载区域 -->
    <section class="download-section" id="download-section">
      <div class="container">
        <h2>立即体验AI魔方</h2>
        <p>免费下载使用，开启智能AI之旅</p>
        <div class="download-buttons">
          <a href="#" class="download-btn windows">
            <img src="@/assets/img/win.svg" alt="Windows版下载 - AI魔方" />
            <span>Windows版</span>
          </a>
          <a href="#" class="download-btn mac">
            <img src="@/assets/img/mac.svg" alt="MAC版下载 - AI魔方" />
            <span>MAC版</span>
          </a>
          <a href="#" class="download-btn linux">
            <img src="@/assets/img/linux.svg" alt="Linux统信版下载 - AI魔方" />
            <span>Linux统信版</span>
          </a>
        </div>
      </div>
    </section>

    <!-- 关于我们 -->
    <section class="about-section" id="about-section">
      <div class="container">
        <h2>关于我们</h2>
        <div class="about-content">
          <div class="about-text">
            <p>AI魔方是一款集成多种AI功能的综合性工具，致力于为用户提供高效、智能的AI解决方案。我们的团队由一群热爱AI技术的专业人士组成，拥有丰富的行业经验和技术积累。</p>
            <p>我们的使命是通过AI技术赋能个人和企业，让AI成为每个人的得力助手。我们相信，AI技术的发展应该惠及每一个人，而不仅仅是少数专业人士。</p>
            <p>自成立以来，我们一直专注于AI技术的研发和应用，不断推出创新产品，为用户提供更加智能、便捷的AI服务。我们的产品涵盖了大模型部署、AI Agent、AI浏览器、智能输入法等多个领域，满足不同用户的多样化需求。</p>
            <p>未来，我们将继续深耕AI领域，不断提升产品性能和用户体验，为构建更加智能的未来贡献力量。</p>
          </div>
          <div class="contact-info">
            <h3>联系方式</h3>
            <p>尹老师 13811587758</p>
            <p>邮箱 800414@qq.com</p>
            <p>座机 010-80696969</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-bottom">
          <p>备案序号：<a href="https://beian.miit.gov.cn" target="_blank">京ICP备17027715号-6</a></p>
          <p>© 2026 AI魔方. 保留所有权利.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'NewHome',
  data() {
    return {
      isMobileMenuOpen: false
    }
  },
  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    scrollToDownload() {
      this.isMobileMenuOpen = false;
      const downloadSection = document.getElementById('download-section');
      if (downloadSection) {
        downloadSection.scrollIntoView({ behavior: 'smooth' });
      }
    },
    scrollToFeatures() {
      this.isMobileMenuOpen = false;
      const featuresSection = document.getElementById('features-section');
      if (featuresSection) {
        featuresSection.scrollIntoView({ behavior: 'smooth' });
      }
    },
    scrollToBrowser() {
      this.isMobileMenuOpen = false;
      const browserSection = document.getElementById('browser-section');
      if (browserSection) {
        browserSection.scrollIntoView({ behavior: 'smooth' });
      }
    },
    scrollToInput() {
      this.isMobileMenuOpen = false;
      const inputSection = document.getElementById('input-section');
      if (inputSection) {
        inputSection.scrollIntoView({ behavior: 'smooth' });
      }
    },
    scrollToWorkstation() {
      this.isMobileMenuOpen = false;
      const workstationSection = document.getElementById('workstation-section');
      if (workstationSection) {
        workstationSection.scrollIntoView({ behavior: 'smooth' });
      }
    },
    scrollToAbout() {
      this.isMobileMenuOpen = false;
      const aboutSection = document.getElementById('about-section');
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
</script>

<style scoped lang="less">
.new-home {
  font-family: '微软雅黑', 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
  color: #333;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  /* 导航栏 */
  .navbar {
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;

    .container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 20px;
    }

    .logo {
      display: flex;
      align-items: center;
      font-size: 24px;
      font-weight: bold;
      color: #333;

      img {
        height: 40px;
        margin-right: 10px;
      }
    }

    .nav-links {
      display: flex;
      align-items: center;

      .nav-link {
        margin-left: 30px;
        color: #333;
        text-decoration: none;
        font-size: 16px;
        transition: color 0.3s ease;

        &:hover {
          color: #1890ff;
        }

        &.btn-primary {
          background: #1890ff;
          color: #fff;
          padding: 8px 16px;
          border-radius: 4px;
          transition: all 0.3s ease;

          &:hover {
            background: #40a9ff;
            color: #fff;
          }
        }
      }
    }

    .mobile-menu-btn {
      display: none;
      cursor: pointer;
      padding: 10px;
      z-index: 1001;

      .hamburger {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 24px;
        height: 18px;

        span {
          display: block;
          width: 100%;
          height: 2px;
          background: #333;
          border-radius: 2px;
          transition: all 0.3s ease;
          transform-origin: center;
        }

        &.is-active {
          span:nth-child(1) {
            transform: translateY(8px) rotate(45deg);
          }
          span:nth-child(2) {
            opacity: 0;
          }
          span:nth-child(3) {
            transform: translateY(-8px) rotate(-45deg);
          }
        }
      }
    }
  }

  /* 英雄区域 */
  .hero {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    padding: 120px 0 80px;
    margin-top: 70px;

    .container {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .hero-content {
      flex: 1;
      max-width: 500px;

      h1 {
        font-size: 48px;
        font-weight: bold;
        margin-bottom: 20px;
        line-height: 1.2;
      }

      p {
        font-size: 18px;
        color: #666;
        margin-bottom: 30px;
        line-height: 1.6;
      }

      .hero-buttons {
        display: flex;
        gap: 15px;

        .btn-primary {
          background: #1890ff;
          color: #fff;
          padding: 12px 24px;
          border-radius: 4px;
          text-decoration: none;
          font-size: 16px;
          transition: all 0.3s ease;

          &:hover {
            background: #40a9ff;
          }
        }

        .btn-secondary {
          background: #fff;
          color: #1890ff;
          padding: 12px 24px;
          border: 1px solid #1890ff;
          border-radius: 4px;
          text-decoration: none;
          font-size: 16px;
          transition: all 0.3s ease;

          &:hover {
            background: #f0f9ff;
          }
        }
      }
    }

    .hero-image {
      flex: 1;
      display: flex;
      justify-content: flex-end;

      img {
        max-width: 100%;
        height: auto;
        border-radius: 10px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
      }
    }
  }

  /* 功能特性 */
  .features {
    padding: 80px 0;
    scroll-margin-top: 80px;

    h2 {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 60px;
    }

    .features-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      gap: 30px;

      .feature-card {
        background: #fff;
        padding: 30px;
        border-radius: 10px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        transition: transform 0.3s ease, box-shadow 0.3s ease;

        &:hover {
          transform: translateY(-10px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }

        .feature-icon {
          width: 60px;
          height: 60px;
          background: #f0f9ff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;

          i {
            font-size: 24px;
            color: #1890ff;
          }
        }

        h3 {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 15px;
        }

        p {
          color: #666;
          line-height: 1.6;
        }
      }
    }
  }

  /* 产品展示 */
  .product-showcase {
    padding: 80px 0;
    background: #f9f9f9;
    scroll-margin-top: 80px;

    .showcase-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 80px;
      scroll-margin-top: 80px;

      &.reverse {
        flex-direction: row-reverse;
      }

      .showcase-content {
        flex: 1;
        max-width: 500px;
        margin-right: 40px;

        &.reverse & {
          margin-right: 0;
          margin-left: 40px;
        }

        h2 {
          font-size: 32px;
          font-weight: bold;
          margin-bottom: 20px;
        }

        p {
          font-size: 16px;
          color: #666;
          margin-bottom: 30px;
          line-height: 1.6;
        }

        .btn-primary {
          background: #1890ff;
          color: #fff;
          padding: 10px 20px;
          border-radius: 4px;
          text-decoration: none;
          font-size: 16px;
          transition: all 0.3s ease;

          &:hover {
            background: #40a9ff;
          }
        }
      }

      .showcase-image {
        flex: 1;

        img {
          max-width: 100%;
          height: auto;
          border-radius: 10px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }
      }
    }
  }

  /* 下载区域 */
  .download-section {
    padding: 80px 0;
    background: #1890ff;
    color: #fff;
    text-align: center;
    scroll-margin-top: 80px;

    h2 {
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 20px;
    }

    p {
      font-size: 18px;
      margin-bottom: 40px;
      opacity: 0.9;
    }

    .download-buttons {
      display: flex;
      justify-content: center;
      gap: 30px;

      .download-btn {
        background: #fff;
        color: #333;
        padding: 15px 30px;
        border-radius: 8px;
        text-decoration: none;
        display: flex;
        align-items: center;
        gap: 10px;
        transition: transform 0.3s ease, box-shadow 0.3s ease;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        }

        img {
          width: 30px;
          height: 30px;
        }

        span {
          font-size: 16px;
          font-weight: bold;
        }

        &.windows {
          background: #f0f0f0;
        }

        &.mac {
          background: #f0f0f0;
        }

        &.linux {
          background: #f0f0f0;
        }
      }
    }
  }

  /* 关于我们 */
  .about-section {
    padding: 80px 0;
    background: #f9f9f9;
    scroll-margin-top: 80px;

    h2 {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 60px;
    }

    .about-content {
      max-width: 800px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      gap: 40px;

      .about-text {
        p {
          font-size: 16px;
          color: #666;
          margin-bottom: 20px;
          line-height: 1.6;
        }
      }

      .contact-info {
        background: #fff;
        padding: 30px;
        border-radius: 10px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);

        h3 {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 20px;
          color: #333;
        }

        p {
          font-size: 16px;
          color: #666;
          margin-bottom: 10px;
          line-height: 1.6;
        }
      }
    }
  }

  /* 页脚 */
  .footer {
    background: #333;
    color: #fff;
    padding: 30px 0;

    .footer-bottom {
      text-align: center;
      color: #ccc;
      font-size: 14px;

      a {
        color: #1890ff;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }

      p {
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .new-home {
    .navbar {
      .mobile-menu-btn {
        display: block;
      }

      .nav-links {
        display: none;
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: #fff;
        flex-direction: column;
        padding: 20px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

        &.is-open {
          display: flex;
        }

        .nav-link {
          margin-left: 0;
          margin-bottom: 15px;
          padding: 10px 0;
          width: 100%;
          text-align: center;

          &:last-child {
            margin-bottom: 0;
          }

          &.btn-primary {
            display: inline-block;
            width: auto;
          }
        }
      }
    }

    .hero {
      .container {
        flex-direction: column;
        text-align: center;
      }

      .hero-content {
        max-width: 100%;
        margin-bottom: 40px;
      }

      .hero-image {
        justify-content: center;
      }
    }

    .product-showcase {
      .showcase-item {
        flex-direction: column;
        text-align: center;

        &.reverse {
          flex-direction: column;
        }

        .showcase-content {
          max-width: 100%;
          margin-right: 0;
          margin-bottom: 40px;

          &.reverse & {
            margin-left: 0;
          }
        }
      }
    }

    .download-section {
      .download-buttons {
        flex-direction: column;
        align-items: center;
      }
    }
  }
}
</style>